import React from 'react';
import { TbAlertStyled } from './tb-alert.styled';
import { SvgImage, SvgType } from '../../../../../../../base/svg/svg';
import ClickableTextProps from '../../../../../../../base/clickable-text/clickable-text';
import { Colors } from '../../../../../../../../colors';
import CircularLoading from '../../../../../../../base/loading/circular-loading/circular-loading';

export interface TBAlertProps {
  onClick: () => void;
  title: string;
  description: string;
  textButton: string;
  loading: boolean;
}

const TBAlert = (props: TBAlertProps) => {
  return (
    <TbAlertStyled.Container onClick={props.onClick}>
      <SvgImage type={SvgType.AlertTb} />
      <TbAlertStyled.Title>{props.title}</TbAlertStyled.Title>
      <TbAlertStyled.Description>{props.description}</TbAlertStyled.Description>
      <TbAlertStyled.ContainerOnClick>
        <ClickableTextProps
          styled={{
            color: Colors.Black,
            textDecoration: 'underlined',
            fontFamily: 'EncodeSans-SemiBold',
            fontSize: '12px !important',
          }}
          clickableText={props.textButton}
          onClick={props.onClick}
        />
        <CircularLoading size={20} loading={props.loading} color={Colors.PrimaryDark} />
      </TbAlertStyled.ContainerOnClick>
    </TbAlertStyled.Container>
  );
};

export default TBAlert;
